import {
  initializeSharedCognitoStorage,
  sweepLegacyAuthCookies,
  sweepLegacyAuthStorage,
} from '@ambr/raven-editor/src/auth/authCookieSweep'

import { resolveCookieDomain } from './components/configure'

/** Removes legacy auth state before the application and its auth modules load. */
export const initializeAuthStorage = (): void => {
  const cookieDomain = resolveCookieDomain(import.meta.env.VITE_COGNITO_COOKIE_STORAGE_DOMAIN)

  if (cookieDomain) {
    sweepLegacyAuthCookies(cookieDomain)
    initializeSharedCognitoStorage(
      cookieDomain,
      import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID
    )
    sweepLegacyAuthStorage()
  }
}
